<template>
<ContentWrapper>
    <div class="content-heading">
      <div>{{page.title}}</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          콘텐츠 관리
        </li>
        <li class="breadcrumb-item active">
          <a :href="page.prevUrl">{{page.prevTitle}}</a>
        </li>
      </ol>
    </div>

    <!-- 정보 -->
    <contentsEditInfo :type="type" :bookSeq="bookSeq" />
    
    <!-- 단원/차시/개체 -->
    <contentsDepth :orgContSeq="info.orgContSeq" :contSeq="info.contSeq"/>

    <loading :active="modalLoading" :is-full-page="true"/>
  </ContentWrapper>    
</template>

<script>
import Vue from 'vue';
import store from "@/store/index";
import { reactive, ref, watch, computed, onMounted } from '@vue/composition-api'
import {dataObject, ValueTexts} from "@/utils/Constants";
import * as textbookApi from "@/api/lm/LmTextBookApi";
import contentsEditInfo from "@/views/contents/contentsEditInfo";
import contentsDepth from "@/views/contents/contentsDepth";
import moment from 'moment';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    components: {contentsEditInfo, contentsDepth, Loading},
    props: {
      type:{
        type:String,
        default:'custContents' // 'custContents':맞춤컨텐츠 관리, 'custClass' : 맞춤강좌 관리
      },
      bookSeq:{
        type:Number,
        default:0
      },
      info:{},
    },
    setup(props, {root}) {
      console.log('contentsDetail setup');
      
      const modalLoading = ref(false);

      const page = reactive({
        bookTypeCd:'',
        title:'',
        prevUrl:'',
        prevTitle:'',
      });
      
      if (props.type == 'custContents') {
        page.bookTypeCd = '330004';
        page.title = `맞춤콘텐츠 상세`;
        page.prevUrl = '/cs/custContentsList';
        page.prevTitle = '맞춤콘텐츠 관리';
      } else if (props.type == 'custClass') {
        page.bookTypeCd = '330005';
        page.title = `맞춤강좌 상세`;
        page.prevUrl = '/cs/custClassList';
        page.prevTitle = '맞춤강좌 관리';
      }

      const retVals = {
        modalLoading,
        page,
        ...methods(props, page),
      }

      onMounted(async () => {
        //await retVals.detail();
      });

      return retVals;
    }
}

function methods(props, page) {

  return {
  }
}
</script>